import React from 'react';
import { ActivityIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { situations, skills } from '../../data/content';
export function Recognize() {
  return <>
      <section className="bg-white px-5 py-16 md:py-24" aria-labelledby="recognize-title" data-id="element-284" data-mp="3p1dhe69mxc5i">
        <div className="mx-auto max-w-6xl" data-id="element-285" data-mp="3t1xghfdrqpua">
          <p className="text-center font-display text-xs font-extrabold uppercase tracking-[0.14em] text-pulse sm:text-sm" data-id="element-286" data-mp="3t0w5fawr63ck">
            Do you recognize yourself in any of these situations?
          </p>
          <h2 id="recognize-title" className="mx-auto mt-3 max-w-4xl text-center font-display text-3xl font-black leading-tight text-navy-900 sm:text-[44px] text-balance" data-id="element-287" data-mp="3k329w26tbdqg">
            If You Answer YES to Any of These, This Collection Was Designed With Your Learning Needs in Mind.
          </h2>

          <div className="mt-12 grid gap-x-10 gap-y-10 md:grid-cols-2 lg:grid-cols-3" data-id="element-288" data-mp="18c80v058r00j">
            {situations.map(s => <article key={s.title} className="border-t-2 border-navy-900 pt-5" data-id="element-289" data-mp="1ifgu12s19zc0">
                <ActivityIcon className="h-7 w-7 text-pulse" aria-hidden="true" data-id="element-290" data-mp="1dhfgexddms7x" />
                <h3 className="mt-3 font-display text-xl font-extrabold leading-snug text-navy-900" data-id="element-291" data-mp="1s6235k5c2m96">{s.title}</h3>
                <div className="mt-3 space-y-2 text-[16px] leading-relaxed text-muted" data-id="element-292" data-mp="1n78qtv1s91al">
                  {s.body.map(p => <p key={p} data-id="element-293" data-mp="zifnhditzr5y">{p}</p>)}
                </div>
              </article>)}
          </div>
        </div>
      </section>

      <section className="ecg-paper px-5 py-16 md:py-24" aria-labelledby="understand-title" data-id="element-294" data-mp="19fkaffki3qnt">
        <div className="mx-auto max-w-3xl rounded-3xl bg-white p-6 shadow-[0_30px_60px_-30px_rgba(6,18,42,0.35)] ring-1 ring-black/5 sm:p-12" data-id="element-295" data-mp="14gh6jyg9bqhf">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.14em] text-pulse sm:text-sm" data-id="element-296" data-mp="2kto2uhbfx6qr">
            Here’s what I want you to understand
          </p>
          <h2 id="understand-title" className="mt-3 font-display text-3xl font-black leading-tight text-navy-900 sm:text-4xl" data-id="element-297" data-mp="2mzcenmc21jua">
            The Challenge Isn’t Always a Lack of ECG Knowledge.
          </h2>
          <p className="mt-4 text-xl font-semibold text-ink" data-id="element-298" data-mp="2wwqt5gef3yjy">
            Sometimes it’s the absence of a <span className="text-pulse" data-id="element-299" data-mp="31wmx5fn47pzi">consistent learning structure.</span>
          </p>
          <p className="mt-6 text-lg text-muted" data-id="element-300" data-mp="248l4iik8tpeu">ECG interpretation combines several related skills:</p>

          <ol className="relative mt-6 space-y-5 border-l-2 border-pulse/30 pl-7" data-id="element-301" data-mp="296wj16lhgo3e">
            {skills.map(skill => <li key={skill} className="relative text-lg font-semibold text-ink" data-id="element-302" data-mp="2e5hgiy9coto5">
                <span className="absolute -left-[37px] top-1.5 h-4 w-4 rounded-full border-[3px] border-white bg-pulse shadow" data-id="element-303" data-mp="2ixhbsdeh6yee" />
                {skill}
              </li>)}
          </ol>

          <div className="mt-8 space-y-4 text-lg leading-relaxed text-ink" data-id="element-304" data-mp="1qg4z5b3vdfar">
            <p data-id="element-305" data-mp="7lk235q58k0l">When these concepts are studied separately, connecting them can become unnecessarily difficult.</p>
            <p data-id="element-306" data-mp="3joy1tgtvsj4">
              That’s why the ECG Interpretation Blueprint™ is organized into{' '}
              <strong className="font-bold" data-id="element-307" data-mp="3uq04y68irnid">six complementary educational volumes.</strong> Each volume focuses on a
              different part of the learning process. Together, they provide a structured reference collection you can
              revisit throughout your professional education.
            </p>
          </div>
        </div>

        <SectionCTA label="Yes! Give me the complete ECG Interpretation Blueprint™" data-id="element-308" data-mp="3g0c5zbnt90xt" />
      </section>
    </>;
}